import { HALApiService } from '../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const postcodesService = new CachedService(entities.Orderadmin_DeliveryServices_Entity_Postcode, '/delivery-services/postcodes', HALApiService, createItemsData)
